import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthenticationService } from '../services/auth.service';
import { SpinnerService } from '../services/spinner.service';

export const authGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Observable<boolean> | Promise<boolean> | boolean => {
  const authService = inject(AuthenticationService);
  const router = inject(Router);
  const spinner = inject(SpinnerService);

  spinner.showSpinner();

  return authService.identity().pipe(
    map((user) => {
      spinner.hideSpinner();
      if (!user || user.platform_role !== 'super_admin') {
        router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
        return false;
      }
      return true;
    }),
    catchError(() => {
      spinner.hideSpinner();
      router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
      return of(false);
    })
  );
};
